import React from "react";
import useAuthStore from "../../store/authStore";

const AccessDenied = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#fff5f5] px-4 py-8 text-center">
      <h1 className="text-[80px] sm:text-[120px] font-bold text-[#e53e3e] leading-none m-0">
        403
      </h1>

      <h2 className="text-xl sm:text-2xl text-[#c53030] my-2">
        Access Denied
      </h2>

      <p className="text-sm sm:text-base text-[#adb5bd] mb-7 max-w-sm">
        You don't have permission to access this page.
      </p>

      <div className="flex flex-wrap gap-3 justify-center">
        <button
          onClick={() => window.history.back()}
          className="px-5 py-2.5 text-sm sm:text-base font-semibold bg-[#e53e3e] text-white rounded-lg hover:bg-[#c53030] transition active:scale-95"
        >
          Go Back
        </button>
        <button
          onClick={() => {
            const role = useAuthStore.getState().role;
            if (role === "ADMIN") window.location.href = "/admin/dashboard";
            else if (role === "MANAGER") window.location.href = "/manager/dashboard";
            else if (role === "EMPLOYEE") window.location.href = "/employee/dashboard";
            else window.location.href = "/login";
          }}
          className="px-5 py-2.5 text-sm sm:text-base font-semibold bg-[#6c757d] text-white rounded-lg hover:bg-[#5a6268] transition active:scale-95"
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default AccessDenied;
